module.exports = __webpack_public_path__ + "img/introduction_img3.db7fe6f6.png";